/* eslint-disable react/prop-types,dot-notation */
import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { t } from 'utils/translates';

import MainNav from './Navs/MainNav';
import EarnMoneyNav from './Navs/EarnMoneyNav';
import MyTasksNav from './Navs/MyTasksNav';
import UsersNav from './Navs/UsersNav';
import CompetitionsNav from './Navs/CompetitionsNav';
import ReferralProgramNav from './Navs/ReferralProgramNav';
import HelpNav from './Navs/HelpNav';

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeNav: this.props.location.pathname.split('/')[1]
    };
  }

  onToggleNav = activeNav => {
    this.setState({
      activeNav: this.state.activeNav === activeNav ? null : activeNav
    });
  };

  render() {
    return (
      <div
        className="page-sidebar page-sidebar_left col-sm-6 col-md-5"
        id="leftSidebar"
        style={{ paddingBottom: '20px' }}
      >
        <NavLink
          to="/my-tasks/create"
          className="btn btn-success btn-block m-b-10"
        >
          <i className="fa fa-plus-circle" /> {t('Создать задание')}
        </NavLink>
        <div
          className="panel-group panel-group-side"
          id="panelGroupMenu"
          role="tablist"
          aria-multiselectable="true"
        >
          <MainNav
            isOpen={this.state.activeNav === 'main'}
            onToggle={() => this.onToggleNav('main')}
          />
          <EarnMoneyNav
            isOpen={this.state.activeNav === 'earn-money'}
            onToggle={() => this.onToggleNav('earn-money')}
          />
          <MyTasksNav
            isOpen={this.state.activeNav === 'my-tasks'}
            onToggle={() => this.onToggleNav('my-tasks')}
          />
          <UsersNav
            isOpen={this.state.activeNav === 'users'}
            onToggle={() => this.onToggleNav('users')}
          />
          {false ? (
            <CompetitionsNav
              isOpen={this.state.activeNav === 'competitions'}
              onToggle={() => this.onToggleNav('competitions')}
            />
          ) : null}
          <ReferralProgramNav
            isOpen={this.state.activeNav === 'referral-program'}
            onToggle={() => this.onToggleNav('referral-program')}
          />
          <HelpNav
            isOpen={this.state.activeNav === 'help'}
            onToggle={() => this.onToggleNav('help')}
          />
          <NavLink
            to="/api-doc"
            className="list-group-item"
            activeClassName="active"
            title="API"
          >
            <span className="list-group-item-val">
              <i className="fa fa-code fa-lg fa-fw" aria-hidden="true" /> API
            </span>
          </NavLink>
        </div>
        <div className="panel-group panel-group-side" role="tablist">
          <a
            href="https://t.me/taskpay_news"
            target="_blank"
            rel="noopener noreferrer"
            className="list-group-item"
          >
            <span className="list-group-item-val">
              <i
                className="fa fa-telegram fa-lg fa-fw me-3"
                aria-hidden="true"
                style={{ color: '#0088cc' }}
              />{' '}
              Telegram чат для общения
            </span>
          </a>
        </div>
        {/* <div className="panel-group panel-group-side" role="tablist">
              <div className="panel panel-default border-b">
                <div className="panel-body">Временный блок</div>
              </div>
              <a
                data-toggle="modal"
                data-target="#timezone"
                className="list-group-item"
              >
                <span className="list-group-item-val">
                  Попап при входе (MT-156)
                </span>
              </a>
              <a href="page_earn_task_desc.html" className="list-group-item">
                <span className="list-group-item-val">
                  Страница задания с позиции исполнителя (MT-13, MT-184, MT-196)
                </span>
              </a>
              <a
                href="page_advertise_task_desc.html"
                className="list-group-item"
              >
                <span className="list-group-item-val">
                  Страница задания с позиции заказчика (MT-185)
                </span>
              </a>
              <a href="page_temp_tries.html" className="list-group-item">
                <span className="list-group-item-val">
                  Карточки выполнения (MT-201)
                </span>
              </a>
            </div> */}
      </div>
    );
  }
}

export default withRouter(Sidebar);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Sidebar/Sidebar.js